<!--suppress ALL -->
<template>
  <div>
    <div class="page case-detail__content">
      <div class="padding15 bg-content m-b-24">
        <div class="bg-content padding15">
          <el-form size="small" label-width="100px" ref="searchRef">
            <el-row :gutter="12">
              <el-col :span="8">
                <el-form-item label="字典键值">
                  <el-input
                    v-model="searchReq.modelCode"
                    placeholder="请输入字典键值"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="字典名称">
                  <el-input
                    v-model="searchReq.modelName"
                    placeholder="请输入字典名称"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select v-model="searchReq.status" filterable clearable placeholder="请选择" style="width: 100%;">
                    <el-option
                      v-for="item in stateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="12">
              <el-col :span="8">
                <el-form-item label="创建时间">
                  <el-date-picker v-model="searchReq.startTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="至">
                  <el-date-picker v-model="searchReq.endTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
              <!-- 按钮操作 -->
              <div class="padding15-tb text right">
                <el-button type="primary" size="small" plain @click="searchReq.page = 1; getList();"><i class="fa fa-search"></i> 搜索</el-button>
                <el-button size="small" @click="reset">重置</el-button>
              </div>
            </el-row>
          </el-form>
        </div>
        <div class="padding15 bg-content">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd"
          >新增</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            :disabled="multiple"
            @click="handleDelByIds"
          >删除</el-button>
          <br/><br/>
          <el-table size="small" :data="dictList.list" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column fixed property="modelType" label="字典类型" align="center"/>
            <el-table-column fixed property="modelCode"  label="字典键值" align="center"/>
            <el-table-column fixed property="modelName"  label="字典名称" align="center"/>
            <el-table-column fixed property="status"  label="状态" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.status === '1'">有效</span>
                <span v-else>无效</span>
              </template>
            </el-table-column>
            <el-table-column fixed property="level"  label="等级" align="center"/>
            <el-table-column fixed property="remark"  label="备注" align="center"/>
            <el-table-column fixed property="createTime"  label="创建时间"  align="center"/>
            <el-table-column fixed label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="updateButton(scope.row)"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
                <el-button type="text" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row)">删除</el-button>

              </template>
            </el-table-column>
          </el-table>
          <div class="text center margin15-tb">
            <el-pagination
              background
              layout="prev, pager, next, sizes, total"
              :total="dictList.totalRecords"
              :page-size="searchReq.limit"
              :current-page="searchReq.page"
              @current-change="currentChange"
              @size-change="sizeChange">
            </el-pagination>
          </div>
        </div>
        <!--    编辑    -->
        <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="字典类型" prop="dictType">
              <el-input v-model="form.modelType" disabled placeholder="字典类型" />
            </el-form-item>
            <el-form-item label="字典名称" prop="dictName">
              <el-input v-model="form.modelName" placeholder="请输入字典名称" />
            </el-form-item>
            <el-form-item label="字典键值" prop="dictType">
              <el-input v-model="form.modelCode" placeholder="字典键值" />
            </el-form-item>
            <el-form-item label="等级" prop="level">
              <el-input v-model="form.level" placeholder="等级" />
            </el-form-item>
            <el-form-item label="字典状态" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio
                  v-for="dict in stateList"
                  :key="dict.value"
                  :label="dict.value"
                >{{ dict.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input v-model="form.remark" type="textarea" placeholder="请输入内容" />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm">确认</el-button>
            <el-button @click="cancel">取消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      searchReq: {
        startTime: null,
        endTime: null,
        page: 1,
        limit: 10,
        order: 'create_time',
        sort: 'desc'
      },
      dictList: { 'totalRecords': 0, list: [] },
      stateList: [
        { value: '0', label: '无效' },
        { value: '1', label: '有效' }
      ],
      modelType: null,
      open: false,
      title: null,
      // 表单参数
      form: {
        status: '1',
        modelType: null,
        modelName: null,
        modelCode: null,
        level: null,
        remark: null
      },
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true
    };
  },
  mounted() {
    this.modelType = this.$route.params && this.$route.params.modelType;
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      this.searchReq.modelType = this.modelType;
      this.$ajax({
        method: 'get',
        url: '/dict/listAll',
        params: this.searchReq
      }).then((res) => {
        this.dictList.list = res.data.list;
        this.dictList.totalRecords = res.data.totalRecords;
        this.loading = false;
      });
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    updateButton(row) {
      this.form.id = row.id;
      this.form.modelType = row.modelType;
      this.form.modelName = row.modelName;
      this.form.status = row.status;
      this.form.remark = row.remark;
      this.form.modelCode = row.modelCode;
      this.form.level = row.level;
      this.open = true;
    },
    resetForm() {
      this.form.modelType = null;
      this.form.modelName = null;
      this.form.status = '1';
      this.form.remark = null;
      this.form.modelCode = null;
      this.form.level = null;
    },
    handleAdd() {
      this.form.id = null;
      this.resetForm();
      this.form.modelType = this.modelType;
      this.open = true;
    },
    handleDelByIds() {
      this.$confirm('是否确认删除 ?', '警告', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method: 'delete',
          url: '/dict/del',
          data: this.ids
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        }).finally(() => {
          this.getList();
        });
      });
    },
    // 重置
    reset() {
      this.searchReq.modelName = null;
      this.searchReq.status = null;
      this.searchReq.remark = null;
      this.searchReq.startTime = null;
      this.searchReq.endTime = null;
      this.searchReq.modelCode = null;
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.getList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.getList();
    },
    submitForm() {
      if (this.form.id) {
        this.$ajax({
          method: 'put',
          url: '/dict/update',
          data: this.form
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
            this.open = false;
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        });
      } else {
        this.$ajax({
          method: 'post',
          url: '/dict/save',
          data: this.form
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
            this.open = false;
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        });
      }
    },
    cancel() {
      this.open = false;
      this.reset();
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm(`是否确认删除字典编码：${row.modelCode} ?`, '警告', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method: 'delete',
          url: `/dict/del/${row.id}`
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        }).finally(() => {
          this.getList();
        });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/dict/list.vue